import { types } from 'mobx-state-tree';

export const ChapterEditingStateEnum = types.enumeration([
  'active',
  'closed',
  'off'
]);
